import { render, staticRenderFns } from "./tn-tag.vue?vue&type=template&id=1d3e4cf5&"
import script from "./tn-tag.vue?vue&type=script&lang=js&"
export * from "./tn-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports